import type { FullEventData } from '../../data/eventSchema'

export const mockEventDetails: FullEventData[] = [
  {
    id: '1',
    eventType: 'book-signing-local',
    eventName: 'Brisbane Indie Author Showcase',
    shortDescription:
      'Join us for an intimate afternoon with local Brisbane romance authors. Get your books signed and chat about your favorite tropes!',
    longDescription:
      'The Brisbane Indie Author Showcase is a premier event for romance readers in Queensland. Featuring over 15 local authors, this intimate signing event allows you to meet your favorite writers, discover new ones, and connect with fellow book lovers.\n\nSchedule:\n1:00 PM - VIP Early Entry\n2:00 PM - General Admission\n4:00 PM - Author Q&A Panel\n5:00 PM - Event Close',
    status: 'tickets-live',
    startDate: '2026-05-15',
    startTime: '13:00',
    endDate: '2026-05-15',
    endTime: '17:00',
    timezone: 'Australia/Brisbane',
    isVirtual: false,
    location: {
      venueName: 'Brisbane City Hall',
      venueType: 'convention-centre',
      streetAddress: '64 Adelaide St',
      city: 'Brisbane',
      region: 'QLD',
      country: 'Australia',
      postcode: '4000',
      roomOrTable: 'Ithaca Auditorium',
      mapLink: 'https://maps.google.com/?q=Brisbane+City+Hall',
    },
    accessRules: {
      ticketRequired: true,
      ticketLink: 'https://eventbrite.com/example-brisbane',
      ticketTiers: [
        {
          id: 't1',
          name: 'General Admission',
          price: 25,
          currency: 'AUD',
          description: 'Entry from 2:00 PM',
        },
        {
          id: 't2',
          name: 'VIP Access',
          price: 65,
          currency: 'AUD',
          description: 'Early entry at 1:00 PM + exclusive swag bag',
          soldOut: true,
        },
      ],
      ageRestriction: '18+',
      bookLimitPolicy: '3 books per author at a time',
      preorderRequired: false,
      outsideBooksAllowed: true,
      photosAllowed: true,
      personalisationAllowed: true,
    },
    visibility: {
      showOnProfile: true,
      showInSearch: true,
      allowCalendar: true,
      allowReminders: true,
    },
    bannerImage:
      'https://images.unsplash.com/photo-1517048676732-d65bc937f952?w=1200',
    coverImage:
      'https://images.unsplash.com/photo-1528605105345-5344ea20e269?w=400',
  },
  {
    id: '2',
    eventType: 'multi-author-convention',
    eventName: 'London Romance Con 2026',
    shortDescription:
      'The biggest romance convention in Europe. Meet over 100 international bestselling authors across a massive 3-day weekend.',
    longDescription:
      'Welcome to London Romance Con 2026! Prepare for three days of panels, signings, parties, and bookish joy. This year features our biggest lineup ever, with authors flying in from around the globe.\n\nHighlights include the Friday Night Masquerade Ball, Saturday Mega-Signing, and Sunday morning "Books & Brunch" sessions.',
    status: 'sold-out',
    startDate: '2026-08-14',
    startTime: '09:00',
    endDate: '2026-08-16',
    endTime: '18:00',
    timezone: 'Europe/London',
    isVirtual: false,
    location: {
      venueName: 'ExCeL London',
      venueType: 'convention-centre',
      streetAddress: 'Royal Victoria Dock, 1 Western Gateway',
      city: 'London',
      region: 'England',
      country: 'United Kingdom',
      postcode: 'E16 1XL',
      mapLink: 'https://maps.google.com/?q=ExCeL+London',
    },
    accessRules: {
      ticketRequired: true,
      ticketLink: 'https://eventbrite.com/example-london',
      ticketTiers: [
        {
          id: 't1',
          name: 'Weekend Pass',
          price: 150,
          currency: 'GBP',
          description: 'Access to all 3 days of signings and panels',
          soldOut: true,
        },
        {
          id: 't2',
          name: 'VIP Weekend',
          price: 250,
          currency: 'GBP',
          description: 'Fast-track lines, VIP lounge access, exclusive merch',
          soldOut: true,
        },
        {
          id: 't3',
          name: 'Masquerade Ball Add-on',
          price: 75,
          currency: 'GBP',
          description: 'Friday night party ticket',
          soldOut: true,
        },
      ],
      ageRestriction: '16+',
      bookLimitPolicy: 'Strictly 3 books per author. You may rejoin the line.',
      preorderRequired: false,
      outsideBooksAllowed: true,
      photosAllowed: true,
      personalisationAllowed: false,
    },
    visibility: {
      showOnProfile: true,
      showInSearch: true,
      allowCalendar: true,
      allowReminders: true,
    },
    bannerImage:
      'https://images.unsplash.com/photo-1540317580384-e5d43616b9aa?w=1200',
    coverImage:
      'https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?w=400',
  },
  {
    id: '3',
    eventType: 'virtual-event',
    eventName: 'Midnight Whispers Cover Reveal & Chat',
    shortDescription:
      'Join me live on Instagram as I reveal the cover for my upcoming dark fantasy romance, Midnight Whispers!',
    longDescription:
      "I am so excited to finally share the cover for Midnight Whispers with you all! I'll be going live on Instagram to do the grand reveal, chat about the inspiration behind the book, read an exclusive excerpt, and answer your questions.\n\nThere will also be a giveaway for a signed ARC during the live stream, so make sure you tune in!",
    status: 'upcoming',
    startDate: '2026-04-10',
    startTime: '20:00',
    endDate: '2026-04-10',
    endTime: '21:00',
    timezone: 'America/New_York',
    isVirtual: true,
    virtualDetails: {
      platform: 'instagram-live',
      accessLink: 'https://instagram.com/example_author',
      replayAvailable: true,
    },
    accessRules: {
      ticketRequired: false,
      ticketTiers: [],
      ageRestriction: 'none',
      preorderRequired: false,
      outsideBooksAllowed: false,
      photosAllowed: true,
      personalisationAllowed: false,
    },
    visibility: {
      showOnProfile: true,
      showInSearch: true,
      allowCalendar: true,
      allowReminders: true,
    },
    coverImage:
      'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?w=400',
  },
  {
    id: 'convention-1',
    eventType: 'romance-mega-signing',
    eventName: 'Romance Mega-Signing 2026',
    shortDescription:
      'Over 50 romance authors under one roof! Get books signed, meet your favorites, and discover new voices at the biggest romance signing event of the year.',
    longDescription:
      "Welcome to Romance Mega-Signing 2026 — the ultimate event for romance readers! This year we're taking over the Hyatt Regency in Dallas for a full day of signings, panels, workshops, and bookish fun.\n\nWith over 50 authors spanning contemporary, dark, fantasy, historical, and paranormal romance, there's something for every reader. Whether you're here for your favorite bestseller or looking to discover your next obsession, this is the event of the year.\n\nHighlights include the morning VIP Meet & Greet, the \"Writing Spice\" panel, a cover model photo booth, and our legendary after-party with live music and book-themed cocktails.\n\nAll attendees receive a swag bag with exclusive bookmarks, ARCs, and signed bookplates from participating authors.",
    status: 'tickets-live',
    startDate: '2026-11-12',
    startTime: '09:00',
    endDate: '2026-11-12',
    endTime: '18:00',
    timezone: 'America/Chicago',
    isVirtual: false,
    location: {
      venueName: 'Hyatt Regency Dallas',
      venueType: 'hotel',
      streetAddress: '300 Reunion Blvd E',
      city: 'Dallas',
      region: 'TX',
      country: 'United States',
      postcode: '75207',
      roomOrTable: 'Reunion Ballroom A-D',
      mapLink: 'https://maps.google.com/?q=Hyatt+Regency+Dallas',
    },
    accessRules: {
      ticketRequired: true,
      ticketLink: 'https://eventbrite.com/example-mega-signing',
      ticketTiers: [
        {
          id: 'ga',
          name: 'General Admission',
          price: 40,
          currency: 'USD',
          description: 'Entry from 10:00 AM, swag bag included',
        },
        {
          id: 'vip',
          name: 'VIP Early Access',
          price: 85,
          currency: 'USD',
          description:
            'Entry at 9:00 AM, VIP Meet & Greet, premium swag bag, front-of-line signing access',
        },
        {
          id: 'party',
          name: 'After-Party Add-On',
          price: 35,
          currency: 'USD',
          description:
            'Evening after-party with live music, cocktails, and author mingling (6:30 PM - 10:00 PM)',
        },
      ],
      ageRestriction: '18+',
      bookLimitPolicy:
        '3 books per author per pass through the line. You may rejoin at the end.',
      preorderRequired: false,
      outsideBooksAllowed: true,
      photosAllowed: true,
      personalisationAllowed: true,
    },
    capacityLimit: 800,
    estimatedAttendance: 650,
    lineCutoffPolicy:
      'Lines for individual authors may be cut off 30 minutes before the event ends.',
    visibility: {
      showOnProfile: true,
      showInSearch: true,
      allowCalendar: true,
      allowReminders: true,
    },
    bannerImage:
      'https://images.unsplash.com/photo-1540317580384-e5d43616b9aa?w=1200',
    coverImage:
      'https://images.unsplash.com/photo-1528605105345-5344ea20e269?w=400',
    highlights: [
      '50+ Romance Authors',
      'Exclusive ARCs & Swag',
      'VIP Meet & Greet',
      'Cover Model Photo Booth',
      'After-Party with Live Music',
    ],
    attendingAuthors: [
      {
        id: 'a1',
        name: 'Elena Richards',
        image:
          'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=300',
        genres: ['Dark Romance', 'Contemporary'],
        tableNumber: 'Table 1',
        signingSlot: '10:00 AM - 2:00 PM',
        books: [
          {
            title: 'The Silent Echo',
            coverImage:
              'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?w=200',
          },
          {
            title: 'Shattered Vows',
            coverImage:
              'https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=200',
          },
        ],
        profileLink: '/author/elena-richards',
      },
      {
        id: 'a2',
        name: 'Marcus Chen',
        image:
          'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300',
        genres: ['Fantasy Romance', 'Paranormal'],
        tableNumber: 'Table 3',
        signingSlot: '10:00 AM - 1:00 PM',
        books: [
          {
            title: 'Crown of Stars',
            coverImage:
              'https://images.unsplash.com/photo-1532012197267-da84d127e765?w=200',
          },
          {
            title: 'Ember & Ash',
            coverImage:
              'https://images.unsplash.com/photo-1512820790803-83ca734da794?w=200',
          },
        ],
        profileLink: '/author/marcus-chen',
      },
      {
        id: 'a3',
        name: 'Amara Knight',
        image:
          'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=300',
        genres: ['Fantasy Romance', 'Romantasy'],
        tableNumber: 'Table 5',
        signingSlot: '11:00 AM - 3:00 PM',
        books: [
          {
            title: 'Throne of Shadows',
            coverImage:
              'https://images.unsplash.com/photo-1589998059171-988d887df646?w=200',
          },
          {
            title: 'The Fae Bargain',
            coverImage:
              'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?w=200',
          },
        ],
        profileLink: '/author/amara-knight',
      },
      {
        id: 'a4',
        name: 'Sarah Johnson',
        image:
          'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=300',
        genres: ['Contemporary Romance', 'Romantic Comedy'],
        tableNumber: 'Table 7',
        signingSlot: '10:00 AM - 2:00 PM',
        books: [
          {
            title: 'Love in the Margins',
            coverImage:
              'https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=200',
          },
          {
            title: 'Second Chance Summer',
            coverImage:
              'https://images.unsplash.com/photo-1532012197267-da84d127e765?w=200',
          },
        ],
        profileLink: '/author/sarah-johnson',
      },
      {
        id: 'a5',
        name: 'Lila Moreno',
        image:
          'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=300',
        genres: ['Historical Romance', 'Regency'],
        tableNumber: 'Table 9',
        signingSlot: '12:00 PM - 4:00 PM',
        books: [
          {
            title: "The Duke's Wager",
            coverImage:
              'https://images.unsplash.com/photo-1512820790803-83ca734da794?w=200',
          },
          {
            title: 'A Season of Scandal',
            coverImage:
              'https://images.unsplash.com/photo-1589998059171-988d887df646?w=200',
          },
        ],
        profileLink: '/author/lila-moreno',
      },
      {
        id: 'a6',
        name: 'Kai Nakamura',
        image:
          'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=300',
        genres: ['MM Romance', 'Contemporary'],
        tableNumber: 'Table 11',
        signingSlot: '10:00 AM - 1:00 PM',
        books: [
          {
            title: 'After the Rain',
            coverImage:
              'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?w=200',
          },
          {
            title: 'Unwritten Rules',
            coverImage:
              'https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=200',
          },
        ],
        profileLink: '/author/kai-nakamura',
      },
      {
        id: 'a7',
        name: 'Priya Sharma',
        image:
          'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=300',
        genres: ['Paranormal Romance', 'Urban Fantasy'],
        tableNumber: 'Table 13',
        signingSlot: '11:00 AM - 3:00 PM',
        books: [
          {
            title: 'Bloodbound',
            coverImage:
              'https://images.unsplash.com/photo-1532012197267-da84d127e765?w=200',
          },
          {
            title: 'Moonlit Oath',
            coverImage:
              'https://images.unsplash.com/photo-1512820790803-83ca734da794?w=200',
          },
        ],
        profileLink: '/author/priya-sharma',
      },
      {
        id: 'a8',
        name: 'Jade Holloway',
        image:
          'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=300',
        genres: ['Dark Romance', 'Mafia Romance'],
        tableNumber: 'Table 15',
        signingSlot: '10:00 AM - 2:00 PM',
        books: [
          {
            title: 'Ruthless King',
            coverImage:
              'https://images.unsplash.com/photo-1589998059171-988d887df646?w=200',
          },
          {
            title: 'Stolen Bride',
            coverImage:
              'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?w=200',
          },
        ],
        profileLink: '/author/jade-holloway',
      },
      {
        id: 'a9',
        name: 'Nora Blake',
        image:
          'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=300',
        genres: ['Romantic Suspense', 'Thriller Romance'],
        tableNumber: 'Table 17',
        signingSlot: '12:00 PM - 4:00 PM',
        books: [
          {
            title: "Don't Look Back",
            coverImage:
              'https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=200',
          },
          {
            title: 'The Last Secret',
            coverImage:
              'https://images.unsplash.com/photo-1532012197267-da84d127e765?w=200',
          },
        ],
        profileLink: '/author/nora-blake',
      },
      {
        id: 'a10',
        name: 'Theo Castellano',
        image:
          'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=300',
        genres: ['Sports Romance', 'New Adult'],
        tableNumber: 'Table 19',
        signingSlot: '10:00 AM - 1:00 PM',
        books: [
          {
            title: 'Offside Hearts',
            coverImage:
              'https://images.unsplash.com/photo-1512820790803-83ca734da794?w=200',
          },
          {
            title: 'Full Court Press',
            coverImage:
              'https://images.unsplash.com/photo-1589998059171-988d887df646?w=200',
          },
        ],
        profileLink: '/author/theo-castellano',
      },
    ],
    schedule: [
      {
        id: 's1',
        time: '9:00 AM',
        endTime: '10:00 AM',
        title: 'VIP Early Access & Meet & Greet',
        description:
          'VIP ticket holders get exclusive early entry, first access to signing lines, and a private meet & greet with featured authors.',
        location: 'Reunion Ballroom A',
        type: 'social',
      },
      {
        id: 's2',
        time: '10:00 AM',
        endTime: '10:15 AM',
        title: 'Doors Open — General Admission',
        description:
          'General admission ticket holders enter. Swag bags distributed at the door.',
        location: 'Main Entrance',
        type: 'break',
      },
      {
        id: 's3',
        time: '10:00 AM',
        endTime: '2:00 PM',
        title: 'Author Signing Session — Block 1',
        description:
          'First signing block. Authors at odd-numbered tables are signing. Check your event map for table locations.',
        location: 'Reunion Ballroom B-D',
        type: 'signing',
        speakers: [
          'Elena Richards',
          'Marcus Chen',
          'Sarah Johnson',
          'Kai Nakamura',
          'Jade Holloway',
          'Theo Castellano',
        ],
      },
      {
        id: 's4',
        time: '11:00 AM',
        endTime: '12:00 PM',
        title: 'Panel: Writing Spice — How Hot Is Too Hot?',
        description:
          'Four authors discuss writing steamy scenes, reader expectations, and where the genre is heading. Audience Q&A included.',
        location: 'Panel Room 1',
        type: 'panel',
        speakers: [
          'Elena Richards',
          'Jade Holloway',
          'Priya Sharma',
          'Nora Blake',
        ],
      },
      {
        id: 's5',
        time: '12:00 PM',
        endTime: '1:00 PM',
        title: 'Lunch Break',
        description:
          'Food trucks and vendors available in the courtyard. Authors rotate tables during this break.',
        location: 'Courtyard',
        type: 'break',
      },
      {
        id: 's6',
        time: '1:00 PM',
        endTime: '2:00 PM',
        title: 'Workshop: Building Your TBR Brand',
        description:
          'Learn how to curate and share your reading life on social media. Tips for BookTok, Bookstagram, and blogging.',
        location: 'Workshop Room',
        type: 'workshop',
        speakers: ['Amara Knight'],
      },
      {
        id: 's7',
        time: '2:00 PM',
        endTime: '4:00 PM',
        title: 'Author Signing Session — Block 2',
        description:
          'Second signing block. Authors at even-numbered tables are now signing. Block 1 authors available for photos.',
        location: 'Reunion Ballroom B-D',
        type: 'signing',
        speakers: ['Amara Knight', 'Lila Moreno', 'Priya Sharma', 'Nora Blake'],
      },
      {
        id: 's8',
        time: '3:00 PM',
        endTime: '4:00 PM',
        title: 'Panel: From Reader to Writer',
        description:
          'Authors share how their reading habits shaped their writing. What books inspired them to pick up a pen?',
        location: 'Panel Room 1',
        type: 'panel',
        speakers: ['Marcus Chen', 'Lila Moreno', 'Theo Castellano'],
      },
      {
        id: 's9',
        time: '4:00 PM',
        endTime: '5:00 PM',
        title: 'Cover Model Photo Booth & ARC Giveaway',
        description:
          'Get your photo taken with cover models! Plus a massive ARC giveaway — over 200 advance copies up for grabs.',
        location: 'Reunion Ballroom A',
        type: 'social',
      },
      {
        id: 's10',
        time: '6:30 PM',
        endTime: '10:00 PM',
        title: 'After-Party: Books & Beats',
        description:
          'The legendary after-party! Live DJ, book-themed cocktails, dancing, and author mingling. After-Party ticket required.',
        location: 'Rooftop Terrace',
        type: 'social',
      },
    ],
    faqItems: [
      {
        question: 'Can I bring books from home to get signed?',
        answer:
          'Yes! Outside books are welcome. You may bring up to 3 books per author per pass through the signing line. Many authors will also have books available for purchase at their tables.',
      },
      {
        question: 'Is there a dress code?',
        answer:
          "No formal dress code, but many attendees dress up! Bookish outfits, cosplay, and themed accessories are encouraged. Comfortable shoes are recommended — you'll be on your feet!",
      },
      {
        question: 'Will there be books available to purchase at the event?',
        answer:
          'Yes! A bookstore partner will have a full selection of titles from all attending authors. Cash and card accepted. Some authors may also sell directly at their tables.',
      },
      {
        question: "What's included in the VIP ticket?",
        answer:
          'VIP includes early entry at 9:00 AM (one hour before GA), a private meet & greet with featured authors, a premium swag bag with exclusive items, and front-of-line access for the first signing block.',
      },
      {
        question: 'Is the event accessible?',
        answer:
          'Absolutely. The Hyatt Regency is fully ADA accessible with elevator access, accessible restrooms, and reserved seating areas. Please contact us in advance if you need specific accommodations.',
      },
    ],
  },
]
